module.exports = __webpack_public_path__ + "static/media/icons.706450d7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/icons/icons.ttf
// module id = 429
// module chunks = 0